export const classTextSchedule = (type, item) =>{
    
    let data = {
        Blocked: "",
        Pagada: "text-programado",
        OnDemand: 'text-oranged',
        Cancelada: 'text-cancelado',
        Pendiente: 'text-pendiente',
        Reagendada: 'text-reagendada',
        CanceladaSinPago: 'text-canceladasinpago',
        PendientePago: 'text-pendientepago',
        Consultorio: 'text-consultorio',
        NoAtendida: 'text-noatendida'
    }

    if(type==='Online' && item.appointment){
        return data[item.appointment.appointmentStatus] || ''
    }else if(type==="OnDemand"){
        return data[type]
    }else{
        return data[type] || ''
    }
}